var _style, _circle, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,256H512c0-23.1-3.1-45.5-8.8-66.8H244.9V256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,122.4h229.6c-15.7-25.6-35.7-48.2-59.1-66.8H244.9V122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c60.2,0,115.6-20.8,159.4-55.7H96.6C140.4,491.2,195.8,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6,389.6h436.9c12.6-20.5,22.3-43,28.8-66.8H8.8C15.2,346.6,25,369,37.6,389.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,256c0-141.4,0-158.1,0-256C114.6,0,0,114.6,0,256H256z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.2,219.1c-35,0-63.3-28.3-63.3-63.3s28.3-63.3,63.3-63.3c10.9,0,21.2,2.8,30.1,7.6 c-14-13.7-33.3-22.2-54.5-22.2c-43,0-77.9,34.9-77.9,77.9s34.9,77.9,77.9,77.9c21.2,0,40.4-8.5,54.5-22.2 C191.4,216.4,181.1,219.1,170.2,219.1L170.2,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.1,111.3l11.2,23.5l25.4-5.9l-11.4,23.4l20.4,16.2l-25.4,5.7l0.1,26.1L188.1,184l-20.3,16.3l0.1-26.1 l-25.4-5.7l20.4-16.2l-11.4-23.4l25.4,5.9L188.1,111.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.18e501cc58d53d239a943becb3fd45f6.svg";
export { ForwardRef as ReactComponent };